module.exports = {
  siteTitle: 'Клуб виртуальной реальности ViRarium', // Site title.
  siteTitleAlt: 'ViRarium', // Alternative site title for SEO.
  siteLogo: '/logos/logo-512x512.png', // todo Logo used for SEO and manifest.
  siteUrl: 'https://virarium.ru', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: 'Клуб виртуальной реальности ViRarium', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml',
  siteFBAppID: '', // FB Application ID for using app insights
  googleTagManagerID: 'GTM-544SPTQ', // GTM tracking ID.
  disqusShortname: 'Virarium', // Disqus shortname.
  userName: 'Virarium',
  userTwitter: 'virarium',
  userLocation: 'TODO',
  userDescription: '',
  copyright: 'Copyright © 2020 ViRarium VR club.', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#003a83', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff', // Used for setting manifest background color.
  email: 'virarium-vrn@yandex.ru',
  phone: '+7(900) 309 67 65',
  vk: 'https://vk.com/virarium',
  vkMe: 'https://vk.me/virarium',
  instagram: 'https://www.instagram.com/virarium_vr_club/',
}